import Button from "@/components/button"
import Topbar from "@/components/topbar"
import { Icon } from "@/icons/icon"
import { logout } from "@/services/auth"
import useStore from "@/store"
import { useNavigate } from "react-router"

export default function NetworkErrorPage() {
  const navigate = useNavigate()
  const { plant } = useStore((state) => state.user)

  async function handleClickGoBack() {
    await navigate(-1)
  }

  return (
    <div className="relative h-dvh">
      <Topbar className="sticky" title="Unit Quality" subtitle={plant.name}>
        <Button className="size-10" variant="outline" onClick={logout}>
          <Icon name="Power" className="text-text-button size-6" />
        </Button>
      </Topbar>

      <div className="p-4 pt-8 mt-15 flex flex-col items-center">
        <Icon name="NetworkError" className="h-25 w-auto mx-auto" />

        <div className="flex flex-col items-center justify-center mt-6">
          <h1 className="text-xl font-semibold">Oops! Something went wrong</h1>

          <div className="text-label-text text-center mt-2">
            Check your internet connection or refresh the page.
          </div>
        </div>

        <Button
          className="grow flex items-center justify-center gap-2.5 mt-10 w-full"
          onClick={handleClickGoBack}
        >
          <span>Go back</span>
        </Button>
      </div>
    </div>
  )
}
